import React from 'react';
import AnswerList from './com.answersList'
import { getAllQuestions } from '../../Actions/a.survey'
import { connect } from 'react-redux'
import { RotateCircleLoading } from 'react-loadingg';

class QuestionList extends React.Component {
    constructor() {
        super();
        this.state = {
            Loading: false
        }
    }
    componentDidMount() {
        this.props.GetQuestions().done((res) => {
            res.length !== 0 ? (this.setState({ Loading: true })) : null;
        }
        );
    }
    render() {
        const { Question } = this.props;

        return (
            <React.Fragment>
                {this.state.Loading === false ? <RotateCircleLoading color="#c535b5" size="default" /> :
                    Question.map((item, index) => (
                        <div className="question-body" key={item.Question.ID} data-id={item.Question.ID} data-valid='0'>
                            <div className="question-title"><span>{index + 1}-</span>{item.Question.Question}</div>
                            <div className="question-answers" id={'radio' + item.Question.ID}>
                                <AnswerList Answers={item.Answers.List}
                                    Type={item.Question.AnswerType}
                                    Id={item.Question.ID}
                                    Text={item.Question.Question}
                                />
                            </div>
                        </div>
                    ))}
            </React.Fragment>
        );
    };
}

var mapDispatchToProps = function (dispatch) {
    return {
        GetQuestions: () => dispatch(getAllQuestions())
    };
}

const mapStateToProps = function (state) {
    return {
        Question: state.Survey.Questions

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionList);


// WEBPACK FOOTER //
// ./src/Components/Requests/com.questionList.jsx